import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Buffer } from "buffer";
import { logo } from "../Data/Images/Home";
import { useResetPasswordLinkMutation } from "../features/auth/authApiSlice";
import { useGetContentsQuery } from "../features/contentsApiSlice";
import "../assets/scss/pages/_login.css";
import CustomLink from "../Components/CustomLink";
import { useTranslation } from "react-i18next";

const ForgetPassword = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const [forgotPasswordLink, { isLoading }] = useResetPasswordLinkMutation();
  const idImage = Buffer.from("58").toString("base64");

  const [email, setEmail] = useState("");
  const [headerImage, setHeaderImage] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const forgotPassword = async (e) => {
    e.preventDefault();
    // toast.success('Password reset link sent successfully. Check Your email', {toastId: 'forgot-password'});
    setErrMsg("");
    if (!email || email === "") {
      setErrMsg(t("Auth_EmailRequired"));
    } else {
      try {
        await forgotPasswordLink({
          email,
        }).unwrap();
        toast.success(
          t("Auth_ResetLinkSent"),
          { toastId: "forgot-password" }
        );
        setTimeout(() => {
          history("/login");
        }, [5000]);
      } catch (err) {
        toast.error(err?.data?.message || t("Auth_GenericError"));
      }
    }
  };

  const { data: fetchHeaderImage, isSuccess: isSuccessImage } =
    useGetContentsQuery({ id: idImage, lang: "en", skip: false });

  useEffect(() => {
    if (isSuccessImage) {
      if (fetchHeaderImage.data.picture)
        setHeaderImage(
          `${process.env.REACT_APP_PUBLIC_URL}${fetchHeaderImage.data.picture}`
        );
    }
  }, [fetchHeaderImage, isSuccessImage]);

  return (
    <>
      <Container
        fluid={true}
        className="login-section section-padding pt-0"
        style={{
          backgroundImage: `linear-gradient(var(--secondary-80),var(--secondary-80)) , url(${headerImage})`,
        }}
      >
        <div className="container d-flex t-flex-col align-items-center justify-content-center vh-100 t-gap-20 md:-t-mt-10">
          <div className="mlogo t-mb-4">
            <CustomLink to="/">
              <img src={logo} alt="" width={120} />
            </CustomLink>
          </div>
          <div className="t-w-full t-max-w-[400px] t-mx-auto t-bg-gray-50 t-flex t-flex-col t-gap-16 t-shadow-lg t-rounded-md !t-py-12 t-px-4">
            <div className="t-text-2xl t-font-bold t-text-center t-text-tertiary">
              {t("Auth_ForgotPasswordTitle")}
            </div>
            <form action="" className="t-flex t-flex-col t-gap-8">
              <p className="t-text-lg t-font-bold !t-m-0 t-text-center">
                {t("Auth_ForgotPasswordHelp")}
              </p>
              <div className="row textboxes">
                <div className="col-12 position-relative">
                  <input
                    type="text"
                    className="form-control "
                    placeholder={t("Email")}
                    aria-describedby="helpId"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  <i className="fa fas fa-envelope !t-text-lg !t-mt-3" />
                </div>
                {errMsg && (
                  <p className="t-text-left t-text-red-500 !t-mt-1">{errMsg}</p>
                )}
              </div>
              <div className="row">
                <div className="col-12 text-center">
                  <button
                    type="button"
                    className="col-12 btn btn-custom-secondary fw-bold lts1 px-5"
                    onClick={(e) => forgotPassword(e)}
                    disabled={isLoading}
                  >
                    {t("Auth_SendResetLink")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </>
  );
};

export default ForgetPassword;
